import { Button } from 'components';
import { getCalculatedText } from 'core';
import { Api, validateEmail } from 'lib';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Login = (props) => {
  const [email, setEmail] = useState(''),
    [code, setCode] = useState(''),
    [password, setPassword] = useState(''),
    [isFocused, setIsFocused] = useState(''),
    [visible, setVisible] = useState(''),
    [codeSent, setCodeSent] = useState(false),
    [err, setErr] = useState(''),
    dispatch = useDispatch(),
    navigate = useNavigate();

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  useEffect(() => {
    if (!visible) return;

    document.getElementById('login-input').focus();
  }, [visible]);

  function handleKeyDown(e) {
    if (e.keyCode !== 13 || !isFocused) return;

    codeSent ? login() : sendCode();
  }

  async function sendCode() {
    const isValid = validateEmail(email);
    if (!isValid) return alert('Please enter a correct email address.');

    const res = await Api.post('/users/sendCode', { email: email.trim() }, 'login');
    if (!res) return alert('No user found!');

    setCodeSent(true);
  }

  async function login() {
    const res = await Api.post('/users/login', { email: email.trim(), code }, 'login');
    if (res.err) return setErr(res.err);
    if (!res) return;

    localStorage.setItem('token', res.token);

    // Add read more previews to the captions
    const userPosts = await Promise.all(
      (res.user?.posts || []).map(async (x) => ({
        ...x,
        calculatedText: await getCalculatedText(x.caption)
      }))
    );

    res.user.posts = userPosts;

    dispatch({
      type: 'INITIAL_DATA',
      payload: { user: res.user }
    });
  }

  return (
    <React.Fragment>
      <Button website sportsSelect isMobile text="Login" onClick={() => navigate('/login')} />
    </React.Fragment>
  );
};

export default Login;

/*
  Old code
*/
// <Modal visible={visible} closeModal={handleModal} website>
//   <Wrapper>
//     <InnerWrapper>
//       <Col pad={isMobile ? '55px 0' : '91px 0'} center>
//         <Text
//           center
//           size='24px'
//           weight='500'
//           col={theme.SECONDARY}
//           marg='0 0 75px'
//         >
//           Login to P4P
//         </Text>
//
//         <Input
//           form
//           website
//           id='login-input'
//           placeholder={codeSent ? 'Login code' : 'Email Address'}
//           onChange={handleChange}
//           value={codeSent ? code : email}
//           // onsubmit={codeSent ? login : sendCode}
//           onFocus={handleFocus}
//           onBlur={handleFocus}
//         />
//
//         <Input
//           form
//           website
//           password
//           onChange={({ target }) => setPassword(target.value)}
//           value={password}
//           onsubmit={passwordLogin}
//           marg='17px 0 0'
//           placeholder='Password'
//         />
//
//         {err && (
//           <Row noFlex center marg='10px 0 0'>
//             <Text size='16px' col={theme.SECONDARY}>{err}</Text>
//           </Row>
//         )}
//
//         <Button
//           website
//           text='Login'
//           marg='30px 0 0'
//           onClick={passwordLogin}
//           action='login'
//         />
//       </Col>
//     </InnerWrapper>
//   </Wrapper>
// </Modal>
